<template>
    <div class="dataList">
        <div class="m-list" v-if="datatype==1">
            <van-collapse v-model="activeNames" v-if="datatype==1">
                <van-collapse-item :name="obj.sectionid" v-for="(obj) in tableData" :key="obj.sectionid">
                    <template #title>
                        <i class="icon-updown icon-ques-updown"></i>
                        <div class="sectionname">{{obj.sectionname}}</div>
                    </template>
                    <div class="ques-outbox double">
                        <van-collapse v-model="obj.activeNames" v-if="obj.taskinfolist.length">
                            <van-collapse-item :name="obj2.sectionid" v-for="(obj2) in obj.taskinfolist" :key="obj2.sectionid">
                                <template #title>
                                    <div class="ques-box ques-innerbox">
                                        <div class="leftbox">
                                            <div class="innerbox">
                                                <div class="innerbox-icon">
                                                    <i class="icon-updown icon-ques-updown" v-if="obj2.childrenlist && obj2.childrenlist.length"></i>
                                                    <i class="icon-dot icon-ques-dot" v-else></i>
                                                </div>
                                                <div class="name">{{obj2.taskname}}</div>
                                            </div>
                                            <div class="total" v-if="obj2.quescount">共 {{obj2.quescount}} 题</div>
                                        </div>
                                        <div>
                                            <div class="rightbox" @click="handleQues(obj2)" v-if="user.isLogin && isjoin && ((type!='0000'&&obj2.quescount) || (type=='0000'&&item.isjoin&&(obj2.quescount||item.qbtype==1)))">
                                                <i class="icon-edit icon-ques-edit"></i>
                                                <div class="tip tc-blue" v-if="type=='0000'">{{obj2.status | statusname}}</div>
                                                <div class="tip tc-blue" v-else>{{obj2.userexamstatus | examstatusname}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div v-if="obj2.childrenlist && obj2.childrenlist.length">
                                    <div class="ques-box" v-for="(obj3) in obj2.childrenlist" :key="obj3.examid">
                                        <div class="leftbox">
                                            <div class="innerbox">
                                                <i class="icon-dot icon-ques-dot"></i>
                                                <div class="name2">{{obj3.taskname}}</div>
                                            </div>
                                            <div class="total" v-if="obj3.quescount">共 {{obj3.quescount}} 题</div>
                                        </div>
                                        <div>
                                            <div class="rightbox" @click="handleQues(obj3)" v-if="user.isLogin && isjoin && ((type!='0000'&&obj3.quescount) || (type=='0000'&&item.isjoin&&obj3.quescount))">
                                                <i class="icon-edit icon-ques-edit"></i>
                                                <div class="tip tc-blue" v-if="type=='0000'">{{obj3.status | statusname}}</div>
                                                <div class="tip tc-blue" v-else>{{obj3.userexamstatus | examstatusname}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </van-collapse-item>
                        </van-collapse>
                        <div class="ques-box ques-innerbox" v-else>
                            <div class="leftbox">
                                <div class="total" style="margin-left: 0.47rem">当前暂无内容</div>
                            </div>
                        </div>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>
        <pull :pull="pull" :page="page" @getList="getList" v-else>
            <NoData v-if="!tableData.length"></NoData>
            <div class="m-list" v-else>
                <div class="ques-outbox single">
                    <div class="ques-box" v-for="(obj) in tableData" :key="obj.examid">
                        <div class="leftbox">
                            <div class="innerbox">
                                <div class="name"><span class="tc-blue" v-if="type=='0105'">[{{obj.topicsectionname}}] </span>{{obj.bankname}}</div>
                            </div>
                            <div class="total" v-if="type=='0105'">
                                <span style="margin-right: 0.1rem">{{obj.datetime}}</span>
                                <span>共{{obj.quescount}}题/对{{obj.finalrightcount}}题</span>
                            </div>
                            <div class="total" v-else>共 {{obj.quescount}} 题</div>
                        </div>
                        <div class="rightbox" @click="handleQues(obj)" v-if="user.isLogin && isjoin">
                            <i class="icon-edit icon-ques-edit"></i>
                            <div class="tip tc-blue" v-if="type=='0105'">{{obj.examstatus | statusname}}</div>
                            <div class="tip tc-blue" v-else>{{obj.userexamstatus | statusname}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Pull>
    </div>
</template>

<script>
  import {question, _filter} from 'api/enumCode'
  import Pull from 'views/mobile/components/pull/pull'
  import {getTopicQuesBankInfo, getTopicUserExamList, updateStartExam} from 'api/api'
  import {mapActions, mapGetters} from 'vuex'
  import NoData from 'views/mobile/components/noData/noData'
  import {getQuestionbankTask} from 'api/questionbank'
  export default {
    name: 'dataList',
    props: ['param', 'type', 'item', 'isjoin'],
    data() {
      return {
        // examstatus：做题状态，0未做（未登录也是这个状态） 1未做完可继续做 10已做完可继续做 11已做完不可继续做
        bankid: '', // datatype==1
        tableData: [],
        datatype: null, // 题库数据类型 1单题库 2多题库
        activeNames: [],
        page: {
          page: 1,
          pagesize: 10,
          pageCount: 0,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
        isInit: false
      }
    },
    created() {
    },
    mounted() {
      if(!this.domainInfo.isMobile){
          this.$router.push({
              name: 'StartTopic'
          })
          return
      }
      this.setNoDataTip(`当前暂无内容`)
      if (this.type === '0000') {
        this.bankid = this.$route.query.qid ? this.$route.query.qid : 'OLLII3p9KBWhHTuZ'
        this.datatype = 1
        this._getTask()
      } else {
        this.getList()
      }
    },
    methods: {
      init() {
        this.bankid = ''
        this.tableData = []
        this.datatype = null
        this.activeNames = []
        this.page = {
          page: 1,
          pagesize: 10,
          pageCount: 0,
          rowCount: 0
        }
        this.pull = {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        }
        this.isInit = false
      },
      initList() {
        if (!this.isInit) {
          this.getList()
        }
      },
      joinExamination(obj){
        this.$router.push({name: 'PaperInfo',query: {bankid: this.bankid, taskid: obj.innerid ? obj.innerid : ''}})
      },
      joinQuestion(obj) {
        let userexamstatus = this.type == '0105' ? obj.examstatus : obj.userexamstatus
        if (userexamstatus == 1 ) {
          let userexamid = this.type == '0105' ? obj.examid : obj.userexamid
          this.$router.push({name: 'MExamView', query: {examid: userexamid}})
        } else {
          this._updateStartExam(obj)
        }
      },
      handleQues(obj) {
        this.setRefresh(true)
        if (this.type === '0000') {
          this.joinExamination(obj)
        } else {
          this.joinQuestion(obj)
        }
      },
      getList() {
        if (this.type == '0105') {
          this._getTopicUserExamList()
        } else {
          this._getList()
        }
      },
      _getList() {
        this.setLoading(true)
        getTopicQuesBankInfo({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            this.isInit = true
            this.datatype = data.data.datatype
            this.bankid = data.data.bankid
            let list = []
            if (this.datatype == 1) {
              list = data.data.bankinfolist
            } else {
              list = data.data.quesbanklist
              this.pull.loading = false
              this.page.pageCount = data.data.pageinfo.pageCount
              this.page.rowCount = data.data.pageinfo.rowCount
              if (this.page.page === this.page.pageCount) {
                this.pull.finished = true
              }
            }
            this._setTableData(list)
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      _getTopicUserExamList() {
        this.setLoading(true)
        getTopicUserExamList({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            let list = data.data.content
            this.isInit = true
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.tableData = list
            } else {
              this.tableData = this.tableData.concat(list)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      _updateStartExam(obj) {
        this.setLoading(true)
        updateStartExam({
          data: {
            assetinnerid: this.datatype == 1 ? this.bankid : obj.bankid,
            taskid: this.datatype == 1 ? obj.taskid : 0,
            examid: obj.examstatus != 1 ? '' : obj.examid,
            topiccode: this.param.examcode
          },
          success: data => {
            this.setLoading(false)
            this.$router.push({name: 'MExamView', query: {examid: data.data}})
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getTask(){
        this.setLoading(true);
        getQuestionbankTask({
          data: {
            bankid: this.bankid
          },
          success: data => {
            this.setLoading(false);
            let list = []
            if (this.item.qbtype == 2) {
              list = data.data.content
              this._setTableData(list)
            } else {
              data.data.content[0].sectionid = this.$route.query.qid
              list = data.data.content
              this.tableData = list
              this.activeNames = [this.$route.query.qid]
              list.forEach(obj => {
                obj.activeNames = []
              })
            }
          },
          error: data => {
            this.setLoading(false);
            this.$message.error(data.msg)
          }
        })
      },
      _setTableData(list) {
        if (this.datatype == 1) {
          list.forEach(obj => {
            obj.activeNames = obj.taskinfolist.length ? [obj.taskinfolist[0].taskid] : []
          })
          this.tableData = list
          this.activeNames = list.length ? [list[0].sectionid] : []
        } else {
          if (this.page.page === 1) {
            this.pull.isLoading = false
            this.tableData = list
          } else {
            this.tableData = this.tableData.concat(list)
          }
        }
      },
      ...mapActions(['setLoading', 'setRefresh', 'setNoDataTip', 'setRefresh'])
    },
    filters: {
      examstatusname(value) {
        return _filter(value, question.examstatus)
      },
      statusname(value) {
        return _filter(value, question.status)
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['refresh', 'domainInfo', 'user'])
    },
    components: {
      Pull, NoData
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.dataList {
    .van-cell{
        border-bottom: 0.01rem solid #E5E5E5;
        &:after{
            display: none;
        }
    }
    .van-collapse-item__content{
        border-bottom: 0.01rem solid #E5E5E5;
        padding-top: 0;
        padding-bottom: 0;
        .double{
            border-left: 0.01rem solid #E5E5E5;
            margin-left: 0.48rem;
            padding-top: 0.24rem;
            .ques-box{
                padding-bottom: 0.24rem;
            }
            .total{
                margin-left: 0.27rem;
            }
            .name{
                // max-width: 5.2rem;
                // margin-right: 0.1rem;
            }
        }
    }
    .van-collapse-item--border:after{
        display: none;
    }
    .van-collapse-item__title .van-cell__right-icon::before{
        display: none;
    }
    .van-collapse-item__title--expanded{
        .van-cell__title{
            .icon-updown{
                &:before{
                    transform: rotate(180deg);
                }
            }
        }
    }
    .van-cell__title{
        display: flex;
        align-items: center;
        .icon-updown{
            align-self: flex-start;
            height: 0.36rem;
            margin-top: 0.03rem;
            margin-right: 0.12rem;
            .sectionname{
                font-size: 0.3rem;
                color: #333;
                line-height: 0.42rem;
            }
            &:before{
                width: 0.36rem;
                height: 0.36rem;
                transition: all .3s;
            }
        }
    }
    .single{
        background: #fff;
        .ques-box{
            padding: 0.2rem 0.32rem;
            border-bottom: 0.01rem solid #E5E5E5;
        }
        .name{
          // margin-right: 0.1rem;
            // max-width: 5.8rem;
        }
    }
    .ques-outbox{
        .van-collapse-item__content{
            padding: 0;
        }
        .van-collapse-item__content{
            border-width: 0;
        }
        .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after, .van-hairline--top::after{
            border-width: 0 !important;
            border-top-width: 0;
        }
        .van-collapse-item{
            .van-cell{
                background: transparent;
                border-width: 0;
                margin-left: -0.2rem;
                width: calc(100% + 0.2rem);
                padding: 0.2rem 0 0 0;
                .van-icon-arrow{
                    display: none;
                }
            }
            .name2{
                font-size: 0.26rem;
                color: #666;
                word-break:break-all;
            }
            .ques-innerbox{
                /*padding-bottom: 0.24rem;*/
                width: calc(100%);
                .innerbox-icon{
                    width: 0.7rem;
                    min-width: 0.7rem;
                    .icon-dot{
                        margin-left: 0.2rem;
                    }
                }
                .total{
                    margin-left: 0.7rem !important;
                }
            }
            .ques-box{
                .total{
                    margin-left: 0.5rem;
                }
            }
        }
        .ques-box{
            display: flex;
            justify-content: space-between;
            .leftbox{
              flex: 1;
              width: 0;
                .innerbox{
                    display: flex;
                }
                .icon-dot{
                    height: 0.4rem;
                    line-height: 0.4rem;
                    width: 0.5rem;
                    min-width: 0.5rem;
                    &:before{
                        width: 0.07rem;
                        height: 0.14rem;
                    }
                }
                .name{
                    font-size: 0.28rem;
                    color: #333;
                    line-height: 0.4rem;
                    word-break:break-all;
                }
                .total{
                    margin-top: 0.06rem;
                    color: #999;
                    font-size: 0.24rem;
                    line-height: 0.32rem;
                }
            }
            .rightbox{
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                margin-left: 0.2rem;
                .icon-edit{
                    &:before{
                        width: 0.48rem;
                        height: 0.48rem;
                        margin-bottom: 0.04rem;
                    }
                }
                .tip{
                    font-size: 0.24rem;
                    line-height: 0.32rem;
                }
            }
        }
    }
    .noData{
        padding-top: 2.5rem;
    }
}
</style>